'use client';

import { type FC } from 'react';
import type { TrackerProvidersProps } from './TrackerProviders.types';
import { HubspotScript } from './_components/HubspotScript';
import { SentryUserReporter } from './_components/SentryUserReporter';
import { TrengoScript } from './_components/TrengoScript';
// import { PHProvider } from '@/_contexts/PosthogProvider';

export const TrackerProviders: FC<TrackerProvidersProps> = ({ children }) => {
  return (
    <>
      <SentryUserReporter />
      <HubspotScript />
      <TrengoScript />
      {children}
      {/* <PHProvider>{children}</PHProvider> */}
    </>
  );
};
